import { Flex, Box } from '@withjoy/joykit';
import React from 'react';
import { DepartmentsTree, DepartmentsTreeProps } from '../DepartmentsTree/DepartmentsTree';
import { ReactComponent as JoyLogo } from '@assets/joy-logo.svg';
import { pxToRem } from '@withjoy/joykit/theme';

export const DepartmentsFooter = (props: DepartmentsTreeProps) => {
  return (
    <Flex height={'100%'} backgroundColor={'gray1'} paddingX={pxToRem(35)} paddingY={pxToRem(64)} alignItems={'center'} flexDirection={'column'}>
      <DepartmentsTree {...props} />
      <Box marginBottom={pxToRem(35)} marginTop={pxToRem(80)} textAlign={'center'} color={'gray3'}>
        <JoyLogo />
      </Box>
    </Flex>
  );
};
